module.exports = {"TXTCLI_Search":{"id":"TXTCLI_Search","defaultMessage":"Suchen","flags":["TRACK"],"track":"Search"}}